// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__1rk3j","spin":"loader_spin__ClUoi","small":"loader_small__UAS+d"};